<nav id="sidebar" class="sidebar-wrapper">
    <div class="sidebar-content">
        <div class="sidebar-brand">
            <a style="height: 34px; width: 100%;">
                <img src="https://storage.googleapis.com/com-next-tech-k8/hospitality_white.svg" alt="logo-hospitality" style="object-fit: contain; height: 100%; width: 100%;">
            </a>
        </div>
        <!-- sidebar-brand -->
        <div class="sidebar-menu">
            <ul>
                @for (sectionmenu of menuSidebar; track $index) {
                    @if (sectionmenu.visible) {
                        <li class="header-menu"><span>{{ sectionmenu.title_section }}</span></li>
                        @for (option of sectionmenu.menu; track $index) {
                            @if (option.visible) {
                                @if (option.submenu) {
                                    <li class="sidebar-dropdown">
                                        <a href="javascript:void(0)"><i class="{{ option.icono }}"></i><span>{{ option.label }}</span></a>
                                        <div class="sidebar-submenu">
                                            <ul>
                                                @for (suboption of option.submenu; track $index) {
                                                    @if (suboption.visible) {
                                                        <li><a href="javascript:void(0)" [routerLink]="suboption.href" routerLinkActive="active">{{ suboption.label }}</a></li>
                                                    }
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                }@else {
                                    @if (option.externalAction) {
                                        <li>
                                            <a href="javascript:void(0)" (click)="onExternalActionClick(option.externalAction)">
                                                <i class="{{ option.icono }}"></i><span>{{ option.label }}</span>
                                            </a>
                                        </li>
                                    } @else {
                                        <li>
                                            <a href="javascript:void(0)" [routerLink]="option.href" routerLinkActive="active">
                                                <i class="{{ option.icono }}"></i><span>{{ option.label }}</span>
                                            </a>
                                        </li>
                                    }
                                }
                            }
                            
                        } 
                    }
                    
                }
               
            </ul>
        </div>
        <!-- sidebar-menu  -->
    </div>
    <!-- sidebar-content  -->
</nav>
<!-- sidebar-wrapper  -->